import { Injectable } from '@angular/core';
import { Cemetery } from '../models/cemetery.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CemeteryService {
  private cemeteries: Cemetery[] = [
    {
      id: 'limes',
      name: 'Partnerfriedhof (Muster)',
      description: 'Platzhalter für Partnerfriedhof-Informationen.',
      location: {
        nearbyCities: [{ name: 'Regional', distance: '-' }]
      },
      features: [],
      documents: [
        {
          title: 'Muster-Dokument',
          downloadUrl: 'assets/limes/muster-dokument.pdf'
        }
      ]
    }
  ];

  private selectedCemeterySubject = new BehaviorSubject<string | null>(null);
  selectedCemetery$ = this.selectedCemeterySubject.asObservable();

  constructor() { }

  getCemeteries(): Cemetery[] {
    return this.cemeteries;
  }

  getCemeteryById(id: string): Cemetery | undefined {
    return this.cemeteries.find(cemetery => cemetery.id === id);
  }

  setSelectedCemetery(id: string | null): void {
    this.selectedCemeterySubject.next(id);
  }
}
